import React, {useState} from "react";
import './SendBox.scss';
//import { closeTroubles } from "../../Menu/MenuSide/menuSideSlice";
import logoUser from '../../../styles/svg_contacts/user-contact.svg';
import logoGroup from '../../../styles/svg_contacts/groups-contacts.svg'
import ContactsData from "./ContactsData/ContactsData";
import { onShadeView, closeSendBox } from "../Contacts/contactsSlice";

const SendBox = (props) => {
    
    const [openContacts, setOpenContacts] = useState(false);
    const { dispatch } = props;

    //OPEN CONTACTS USERS
    const onClickOpenContactUser = () =>{
       // console.log('OPEN CONTACTS DATA');
        setOpenContacts(!openContacts);
      //  dispatch(closeTroubles());
    }

    // CLOSE SEND BOX
const handleCloseSendBox = () => {

    dispatch(closeSendBox());
    dispatch(onShadeView());
    setOpenContacts(false);



}
    
    
    //RENDER SENDBOX

    const renderSendBox = () => {
        return (
            <div >
                <div className="box-button">
                    <button className="close-button" onClick={handleCloseSendBox}></button>
                </div>
                <div className="box">
                    <img src={logoGroup} alt='user'/> 
                    <button className="button-check">Группы</button>
                </div>
                <div className="box">
                    <img src={logoUser} alt='user'/>
                    <button className="button-check" onClick={onClickOpenContactUser}>Пользователи</button>
                </div>
                
                   
            </div>
        )
    }
        //RENDER CONTACTS
        const renderContacts = () => {
            return (
                <div>
                    <ContactsData
                    contactsData = {props.contactsData}
                    dispatch={dispatch}
                    userId={props.userId}
                    noteData={props.noteData}
                    onClickOpenContactUser={onClickOpenContactUser}
                    mesHref={props.mesHref}
                    mesCategory={props.mesCategory}
                    quizId={props.quizId}
                    quizName={props.quizName}
                    />
                    
                    
                </div>
            )
        }


    //RENDER
    const sendBoxView = props.contactsStore.openSendBox;
    //console.log(sendBoxView);
    if (sendBoxView) {
        return (
            <div className="SendBox">
                {renderSendBox()}
                {openContacts ? renderContacts() : null}
                
                   
            </div>
        )
    } else return null;
}
export default SendBox;